<template lang="html">
  <article class="media">
    <div class="media-content">
      <div class="content">
        <p>
          <strong>Software Engineer, II</strong> | InTouch Health - <small>Feb 2017 - May 2018</small>
          <br>
At InTouch I brought DevOps practices to bare metal operating system builds.
I was reponsible for managment of services on AWS, mitigating security breaches,
implementing security fixes via automation, and producing tooling to help
multiple teams more effectively understand their own infrastructure. I designed
and coded multiple projects adopted by other teams to increase stability within
their domains. Between Slackbots, port-monitoring dashboards, screen scraping,
and API building, this job allowed me to sharpen my toolset and introduce new
ways to solve legacy challenges.
        </p>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: "intouch"
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/jobs/InTouch.vue